import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"

@Component({
	selector: "app-toast",
	imports: [],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `<div
		class="snackbar"
		[class.doShow]="isShow"
	>
		{{ message }}
	</div>`,
})
export class ToastComponent implements OnInit {
	//outputs the toast message
	message: string = "" //actual written message
	isShow: boolean = false //is in show state flag
	inTimeout: boolean = false
	timeout: any = null
	constructor(
		public modalService: ModalService,
		private store: StoreService,
		private lang: LangService
	) {}

	ngOnInit() {
		this.modalService.toastSubj.subscribe((mes: string) =>
			this.show(this.lang.getVal(mes))
		)
	}

	async show(message: string) {
		//show the message

		if (this.timeout) {
			if (message == this.message) {
				return
			}
			this.isShow = false
			this.timeout = null
			await this.store.timeout(50)
			this.show(message)
			return
		}

		this.message = message //update the message
		this.isShow = true //turn the show flag true
		this.setTimeout()
	}
	setTimeout() {
		this.timeout = setTimeout(() => {
			//after 3 seconds - turn the show flag back to false

			this.isShow = false
			this.timeout = null
		}, 3000)
	}
}
